import React from 'react';
import { SectionHeading } from './SectionHeading';
import { visualFeatures } from '../data/copy';

/** What the pages look like inside: a scannable list of visual formats. */
export function VisualSection() {
  return <section className="w-full bg-slate-900 py-10 [contain-intrinsic-size:auto_900px] [content-visibility:auto] sm:py-14 [.chalk_&]:bg-white" aria-labelledby="visual-heading" data-id="element-233" data-mp="2tq0ji72s2nz">
      <div className="mx-auto max-w-4xl px-6 text-center" data-id="element-234" data-mp="3p9u8p2ajiwr9">
        <SectionHeading eyebrow="Built to be visual" title={<span id="visual-heading" data-id="element-236" data-mp="3u1c6jhh9oh80">This is not a wall of basketball theory.</span>} lead="Inside the system you will see:" data-id="element-235" data-mp="3p89e5co87dte" />

        <ul className="mx-auto mt-7 flex max-w-3xl flex-wrap justify-center gap-2" data-id="element-237" data-mp="3gb8s3comprt4">
          {visualFeatures.map(item => <li key={item} className="rounded-full border border-slate-800 bg-slate-950 px-3.5 py-1.5 text-sm font-medium text-slate-50 [.chalk_&]:border-slate-200 [.chalk_&]:bg-slate-50 [.chalk_&]:text-slate-900" data-id="element-238" data-mp="3l90iu3djf7vq">
              {item}
            </li>)}
        </ul>

        <p className="mt-9 text-lg text-slate-400 [.chalk_&]:text-slate-600" data-id="element-239" data-mp="eqixa3wgbem6">The goal is simple:</p>
        <p className="mx-auto mt-1 max-w-2xl text-2xl font-extrabold uppercase leading-tight tracking-tight text-orange-400 sm:text-3xl [.chalk_&]:text-orange-600" data-id="element-240" data-mp="9rfruick76do">
          Open the page and understand what to do in seconds.
        </p>
      </div>
    </section>;
}